var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-menus"},_vm._l((_vm.menus),function(menu){return _c('router-link',{key:menu.name,staticClass:"menu",class:{active: menu.name === _vm.active},attrs:{"to":{
    name: menu.name,
    query: { id: _vm.id }
  },"tag":"div"}},[_c('span',[_vm._v(_vm._s(menu.label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }